// setExclusivePrivateRunOutAt.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import getMeBalance from '../selector/getMeBalance.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getStreamTokenDecodedData from '../selector/getStreamTokenDecodedData.js';
import { getLiveStreamExclusivePrivatePrice } from '../selector/getLiveStreamPrice.js';

import {
  CHARGE_PERIOD_SECONDS,
  ExclusivePrivateStatus,
} from '../resource/liveStreamConstants.js';

/**
 * Store the "run out at" unix timestamp used by the exclusive private (1v1)
 * affordable-watch-time.
 * @kind action
 * @param {object} params
 * @param {string} params.streamId - stream id.
 * @param {number} params.tokenExp - stream token exp in unix seconds.
 * @return {Promise} Action promise.
 */
const setExclusivePrivateRunOutAt =
  ({ streamId, tokenExp } = {}) =>
  async (dispatch, getState) => {
    if (!streamId) {
      return dispatch({ type: '' });
    }

    const state = getState();
    const exclusivePrivateStatus = getLiveStreamData(
      state,
      [streamId, 'exclusivePrivate'],
      'status'
    );
    const exclusivePrice = getLiveStreamExclusivePrivatePrice(state, streamId);
    const balance = getMeBalance(state);
    const resolvedTokenExp =
      tokenExp ?? getStreamTokenDecodedData(state, streamId)?.exp;

    const isExclusivePrivatePerforming =
      ExclusivePrivateStatus.PERFORMING === exclusivePrivateStatus;
    const runOutAt =
      isExclusivePrivatePerforming && resolvedTokenExp && exclusivePrice > 0
        ? resolvedTokenExp +
          Math.floor(balance / exclusivePrice) * CHARGE_PERIOD_SECONDS
        : null;

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream', 'paid', streamId],
        data: { exclusivePrivateRunOutAt: runOutAt },
      },
    });
  };

export default setExclusivePrivateRunOutAt;
